/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type loginOnelogin_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly " $refType": "loginOnelogin_viewer";
};
export type loginOnelogin_viewer$data = loginOnelogin_viewer;
export type loginOnelogin_viewer$key = {
    readonly " $data"?: loginOnelogin_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"loginOnelogin_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginOnelogin_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '3e90163c8d17543cca9f0f069e8f6e58';
export default node;
